import {UserInterfaceConfigurationService} from "../../../services/configuration/UserInterfaceConfigurationService";
import {IGridApi, IUiGridConstants} from "ui-grid";
import EquityPositionsViewColumns from "./EquityPositionsViewColumns";
import {IScope} from "angular";
import {SystemEventService} from "../../../services/system-state/SystemEventService";
import {SystemEvent} from "../../../services/system-state/SystemEvent";
import IUiGridTreeBaseConstants = uiGrid.treeBase.IUiGridTreeBaseConstants;

const GridPreferencesKey = "equity-position-view-grid-settings";

/*
 * Building the UI Grid options is ugly, so I'm moving all of the ugliness down here
 * even if it makes the code look horrifying in this one spot
 */
export default function(scope: IScope,
                        gridApiFn: (gridApi: any) => void,
                        configService: UserInterfaceConfigurationService,
                        systemEventService: SystemEventService,
                        gridUtil: any,
                        uiGridConstants: IUiGridConstants,
                        uiGridTreeBaseConstants: IUiGridTreeBaseConstants) {
    const saveTablePreferences = (gridApi: IGridApi) => {
        return () => {
            const data = gridApi.saveState.save();
            return configService.save(GridPreferencesKey, data);
        };
    };

    return  {
        tableName: "Positions Search",
        flatEntityAccess: false,
        enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enableFiltering: true,
        saveFilter: true,
        showColumnFooter: true,
        showTreeExpandNoChildren: true,
        saveSort: true,
        saveScroll: false,
        saveFocus: false,
        minRowsToShow: 20,
        enableGridMenu: false,
        enablePaging: false,
        excessRows: 15,
        treeRowHeaderAlwaysVisible: false,
        columnDefs: EquityPositionsViewColumns(uiGridConstants, uiGridTreeBaseConstants),
        exporterMenuCsv: false,
        exporterMenuPdf: false,
        onRegisterApi: (gridApi: any) => {
            gridUtil.disableAnimations(gridApi.grid.element);
            gridApi.colMovable.on.columnPositionChanged(scope, saveTablePreferences(gridApi));
            gridApi.core.on.filterChanged(scope, saveTablePreferences(gridApi));
            gridApi.core.on.sortChanged(scope, saveTablePreferences(gridApi));
            gridApi.core.on.columnVisibilityChanged(scope, saveTablePreferences(gridApi));
            gridApi.colResizable.on.columnSizeChanged(scope, saveTablePreferences(gridApi));

            setTimeout(async () => {
                const data = await configService.load(GridPreferencesKey);
                if (data != null) {
                    gridApi.saveState.restore(scope, data);
                }
            });
            const sub = systemEventService.eventsOfType(SystemEvent.VIEW_RESIZE)
                                          .subscribe(() => gridApi.grid.handleWindowResize());
            scope.$on("$destroy", () => sub.unsubscribe());

            gridApiFn(gridApi);
        },
        columnPresets: [
            {
                name: "Desktop",
                icon: "icon-desktop",
                minWidth: 1200,
                resetFn: EquityPositionsViewColumns(uiGridConstants, uiGridTreeBaseConstants)
            }
        ]
    };
}
